<div class="recurrence-panel bg-[#f8fbff] rounded-lg p-3 font-normal text-corporate-3 h-auto">
    <div class="flex flex-wrap items-center gap-2 text-[13px] leading-7">
        <span>Repetir cada</span>
        <div class="recurrence-stepper flex items-center gap-1">
            <button type="button" class="stepper-btn" (click)="decrementEvery()">-</button>
            <input class="stepper-input" type="number" value="1" min="1" [(ngModel)]="every">
            <button type="button" class="stepper-btn" (click)="incrementEvery()">+</button>
        </div>
        <span *ngIf="type=='daily'">día empezando el {{this.dateFrom}}</span>
        <span *ngIf="type=='weekly'">semana empezando el {{this.dateFrom}} el:</span>
        <span *ngIf="type=='monthly'">mes empezando el {{this.dateFrom}}</span>
        <span *ngIf="type=='annually'">año empezando el {{this.dateFrom}}</span>
    </div>

    <div *ngIf="type=='weekly'" class="flex flex-wrap gap-2 mt-2">
        <label *ngFor="let item of arrDaysWeek" class="app-checkbox flex items-center gap-1.5 text-[13px] font-medium text-corporate-3 cursor-pointer mb-0">
            <input type="checkbox" value={{item.checked}} name={{item.value}} [(ngModel)]="item.checked" (change)="changeCheckbox($event,item.value, item.checked)" class="app-checkbox-input">
            <span class="app-checkbox-box"></span>
            <span>{{item.name}}</span>
        </label>
    </div>

    <div *ngIf="type=='monthly'" class="flex flex-wrap items-center gap-2 mt-2 text-[13px]">
        <span>el</span>
        <div class="recurrence-select-wrapper">
            <app-select
                [options]="[{value:'dayNumber', label: dayNumber + ' º día'}, {value:'positionDay', label: pos + ' º ' + dayName}]"
                [(ngModel)]="montly"
            ></app-select>
        </div>
        <span>de cada mes</span>
    </div>

    <div *ngIf="type=='annually'" class="flex flex-wrap items-center gap-2 mt-2 text-[13px]">
        <div class="recurrence-select-wrapper">
            <app-select
                [options]="[{value:'dayNumberAnnually', label: dayNumber + ' º día ' + monthName}, {value:'positionDayAnnually', label: pos + ' º ' + dayName + ' de ' + monthName}]"
                [(ngModel)]="annually"
            ></app-select>
        </div>
        <span>de cada año</span>
    </div>

    <div class="flex flex-wrap items-center gap-2 mt-2 text-[13px]">
        <span>y continúa</span>
        <div class="recurrence-select-wrapper recurrence-select-narrow">
            <app-select
                [options]="[{value:'forever', label:'para siempre'}, {value:'count', label:'durante'}, {value:'until', label:'hasta'}]"
                [(ngModel)]="selected"
            ></app-select>
        </div>
        <div *ngIf="selected=='count'" class="recurrence-stepper flex items-center gap-1">
            <button type="button" class="stepper-btn" (click)="decrementCount()">-</button>
            <input class="stepper-input" type="number" value="1" min="1" [(ngModel)]="count">
            <button type="button" class="stepper-btn" (click)="incrementCount()">+</button>
        </div>
        <span *ngIf="selected=='count'">veces</span>
        <div *ngIf="selected=='until'" class="inline-block">
           <input id="select-picker" (click)="setActive($event)" class="recurrence-date-input" placeholder="{{this.dateTo}}" tabindex="2" type="text" readonly>
           <div style="display:none" id="date-picker" class="z-[10000] absolute">
             <app-date-picker-recurrence (dateSelected)="clickDateSelected($event)"></app-date-picker-recurrence>
           </div>
        </div>
        <a class="recurrence-finish-btn" (click)="saveRecurrence()">Finalizado</a>
    </div>
</div>